import { useMemo } from 'react'

import { type CoreProduct, type CoreBundle } from '@flecto/types'

export function useProductToBundle(
  product: Partial<CoreProduct>
): Partial<CoreBundle> {
  return useMemo(() => {
    if (!product.bundle || !product.bundle_attributes)
      throw new Error('Product is not a bundle or is missing bundle_attributes')

    const attrs = product.bundle_attributes

    return {
      id: product.id,
      internal_id: product.internal_id,
      title: product.title,
      description: product.description,
      status: product.status,
      on_store: product.on_store,
      bundle: true,
      item_type: 'bundle',
      main_photo: product.main_photo ?? null,
      category_id: product.category_id,
      categories: product.categories ?? null,
      insured: product.insured,
      photos: product.photos,
      bundle_items: attrs.bundle_items,
      apply_general_discount_to_bundle: attrs.apply_general_discount_to_bundle,
      apply_general_discount_amount: attrs.apply_general_discount_amount,
      apply_general_discount_type: attrs.apply_general_discount_type,
      created_at: product.created_at,
      updated_at: product.updated_at,
    }
  }, [product])
}
